import { ChildMachineConfig } from "@checkout/types";
import { ActionTypes } from "./actions";
import { GuardTypes } from "./guards";
import { ServiceTypes } from "./services";
import { PriceFreezeState } from "./types";

export const getMachineState = (config: ChildMachineConfig) => ({
  initial: PriceFreezeState.route,
  id: "airPriceFreezeMachine",
  states: {
    [PriceFreezeState.route]: {
      always: [
        {
          target: PriceFreezeState.initialize,
          cond: GuardTypes.hasPriceFreezeId,
        },
        {
          target: config.nextState,
        },
      ],
    },
    [PriceFreezeState.initialize]: {
      initial: "fetchPriceFreeze",
      states: {
        fetchPriceFreeze: {
          invoke: {
            src: ServiceTypes.fetchPriceFreezeService,
            onDone: {
              actions: ActionTypes.setPriceFreezeFromData,
              target: config.nextState,
            },
            onError: {
              target: `#airPriceFreezeMachine.${PriceFreezeState.error}`,
            },
          },
        },
      },
    },
    [PriceFreezeState.error]: {},
  },
});

export const getPriceFreezeDiscountMachineState = (
  config: ChildMachineConfig
) => ({
  initial: PriceFreezeState.route,
  states: {
    [PriceFreezeState.route]: {
      always: [
        {
          target: PriceFreezeState.addDiscount,
          cond: GuardTypes.hasPriceFreezeId,
        },
        {
          target: config.nextState,
        },
      ],
    },
    [PriceFreezeState.addDiscount]: {
      always: [
        {
          actions: ActionTypes.setPriceFreezeDiscount,
          target: config.nextState,
        },
      ],
    },
  },
});
